import React, { Component } from "react";
import { connect } from "react-redux";
import AppBar from "../../components/AppBar/AppBar"
import { Player, ControlBar, BigPlayButton } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css"; // import css
import store from "../../store/store";
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import Button from '@material-ui/core/Button';
import 'typeface-roboto';
import Typography from '@material-ui/core/Typography';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import FastForwardIcon from '@material-ui/icons/FastForward';
import IconButton from '@material-ui/core/IconButton';

import "./Main.css";
let currentValue = 0;

const sessions =  
[
    {
        "reps": 3,
        "exercises": [
            {
                "type":"exercise",
                "name":"Elongación dinámica pectorales + movilidad de psoas",
                "time": 15,
                "video": "videos/1-1-1.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 10,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Rebotes piernas separadas",
                "time": 15,
                "video": "videos/1-2-2.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 10,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Skipping en el lugar",
                "time": 20,
                "video": "videos/1-3-3.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 60,
                "video": "videos/pause.m4v"
            }

        ]
    },
    {
        "reps": 4,
        "exercises": [
            {
                "type":"exercise",
                "name":"Abdominal bolita alternado",
                "time": 20,
                "video": "videos/2-1-4.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 10,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Abdominal oblicuos",
                "time": 15,
                "video": "videos/2-2-5.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 10,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Plancha de codo a manos",
                "time": 20,
                "video": "videos/2-3-6.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 60,
                "video": "videos/pause.m4v"
            }

        ]
    },
    {
        "reps": 4,
        "exercises": [
            {
                "type":"exercise",
                "name":"Press acostado con botellas",
                "time": 30,
                "video": "videos/3-1-7.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 15,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Elevación de cadera + patada",
                "time": 30,
                "video": "videos/3-2-8.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 15,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Abdominal bisagra",
                "time": 30,
                "video": "videos/3-3-9.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 15,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Sentadilla Sumó con botellas",
                "time": 30,
                "video": "videos/3-4-10.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 15,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Remo + Vuelo Posterior en postura",
                "time": 30,
                "video": "videos/3-5-11.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 15,
                "video": "videos/pause.m4v"
            },
            {
                "type":"exercise",
                "name":"Saltos con abeducciones de cadera + vuelos frontales con botella",
                "time": 30,
                "video": "videos/3-6-12.m4v"
            },
            {
                "type": "pause",
                "name":"Pausa",
                "time": 90,
                "video": "videos/pause.m4v"
            }

        ]
    }
]

const renderTime = value => {

    if (value === 0) {
      return <div className="timer"> <div className="value">0</div></div>;
    }
  
    return (
      <div className="timer">
        <div className="value">{value}</div>
      </div>
    );
  };

class Main extends Component {



    constructor(props) {
		super(props);
		this.state = {
            timerDuration: 0,
            isPlaying: false,
            currentSession: 0,
            currentSessionReps: 0,
            currentExercise: 0,
            currentExerciseName:"", 
            started: false
        };
        
	}
    componentDidMount() {

        const { player } = this.player.getState();
        this.player.subscribeToStateChange(this.handleStateChange.bind(this));

    }
    
    handleStateChange(state, prevState) {
        // copy player state to this component's state
        this.setState({
          player: state,
          currentTime: state.currentTime,
          isPlaying: !state.paused
        });
        
      }

    Pause  = () => {
        this.setState({
            isPlaying: false
        });
        this.player.pause();
    }

    Resume = () => {
        this.setState({
            isPlaying: true
        });
        this.player.play();
    }

    Forward = () => {
        this.onTimerComplete();
    }

    StartLesson = () => {
        var curSession = sessions[this.state.currentSession];
        
        if(this.state.currentSessionReps < curSession.reps)
        {
            if(this.state.currentExercise < curSession.exercises.length )
            {
                var exercise = curSession.exercises[this.state.currentExercise];
                this.setState({
                    timerDuration : exercise.time,
                    isPlaying: true,
                    video: exercise.video,
                    currentExerciseName:exercise.name,
                    started: true
                });
                this.player.autoplay = true;
                this.player.load();
            }
        }
    }

    onTimerComplete = () => {
        var curSession = sessions[this.state.currentSession];
        var nextExercise = ++this.state.currentExercise;
        
        if(nextExercise < curSession.exercises.length )
        {
            //Same Session
            var exercise = curSession.exercises[nextExercise];
            this.setState({
                timerDuration : exercise.time,
                video: exercise.video,
                currentExercise: nextExercise,
                isPlaying: true,
                currentExerciseName:exercise.name
            });
            this.player.load();
        }else{
            var curReps = ++this.state.currentSessionReps; 
            if(curReps < curSession.reps)
            {
                nextExercise = 0;
                var exercise = curSession.exercises[nextExercise];
                this.setState({
                    timerDuration : exercise.time,
                    video: exercise.video,
                    currentExercise: nextExercise,
                    currentSessionReps: curReps,
                    isPlaying: true,
                    currentExerciseName:exercise.name
                });
                this.player.load();
            }else{
                //Next Session
                var nextSession = ++this.state.currentSession;
                if(nextSession < sessions.length)
                {
                    curSession = sessions[nextSession];
                    nextExercise = 0;
                    var exercise = curSession.exercises[nextExercise];
                    this.setState({
                        timerDuration : exercise.time,
                        video: exercise.video,
                        currentExercise: nextExercise,
                        currentSession: nextSession,
                        currentSessionReps: 0,
                        isPlaying: true,
                        currentExerciseName:exercise.name
                    });
                    this.player.load();

                }else{
                    //Finish
                }
            }
        }
    }

	render() {
		return (
			<React.Fragment>
            <div className="main" >
                <div
                style={{width:"20%", textAlign:"left", marginTop: "25px"}}>
                <CountdownCircleTimer
                        isPlaying={this.state.isPlaying}
                        key={this.state.timerDuration}
                        durationSeconds={this.state.timerDuration}
                        colors={[
                            ['#004777', .33],
                            ['#F7B801', .33],
                            ['#A30000']
                        ]}
                        renderTime={renderTime}
                        onComplete={() =>{this.onTimerComplete(); return [true, 1000]}}
                        />
                        
                </div>
                
                <div >
                <Button variant="contained" color="primary" className={this.state.started ? "buttonStartHide":"buttonStart"} onClick={this.StartLesson} >
                    COMENZAR
                </Button>
                </div>
                <div>
                <IconButton color="primary" aria-label="Pausa" className={!this.state.isPlaying ? "buttonPauseHide":"buttonPause"}  onClick={this.Pause} component="span">
                    <PauseCircleFilledIcon style={{height:"80%", width:"80%"}}/>
                </IconButton>

                </div>

                <div>
                <IconButton color="primary" aria-label="Play" className={this.state.isPlaying || !this.state.started ? "buttonPauseHide":"buttonPause"}  onClick={this.Resume} component="span">
                    <PlayCircleFilledIcon style={{height:"80%", width:"80%"}}/>
                </IconButton>

                </div>

                <div>
                <IconButton color="primary" aria-label="Forward" className={!this.state.started ? "buttonForwardHide":"buttonForward"}  onClick={this.Forward} component="span">
                    <FastForwardIcon style={{height:"80%", width:"80%"}}/>
                </IconButton>

                </div>

                

                <div style={{height:"100%", display:"contents"}}>
               
                    <Player
                        ref={(player) => { this.player = player }}
                        playsInline
                        autoPlay
                        poster="/assets/poster.png"
                        style={{zIndex:"-1"}}
                        loop={true}
                        disableCompletely={true}
                       >
                        <source src={this.state.video} />
                        <BigPlayButton position="center" className="bigplay"/>
                        <ControlBar hide={true} disableDefaultControls={true} className="bigplay"/>
                    </Player>
                </div>
                <div style={{backgroundColor: "rgba(0,0,0,0.7)",width:"70%", marginLeft:"15%" ,textAlign:"center", position: "absolute", color: "white", zIndex: "98",bottom:"5%"}}>
                    <Typography variant="h3" component="h2" gutterBottom style={{marginTop: "10px"}}>
                        {this.state.currentExerciseName}
                    </Typography>
                </div>
                </div>
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
	};
};

export default connect(mapStateToProps)(Main);
